import { InputFieldType } from "@/components/common/InputFieldType";

export class ValidationResult {
    isValid: boolean;
    errorLabel: string;
    
    constructor(isValid: boolean = true, errorLabel: string = '')
    {
        this.isValid = isValid;
        this.errorLabel = errorLabel;
    }
}

export const IsBusinessId = function(value: string, required: boolean = false): ValidationResult {
    // TODO: Eliminate repetition
    const isNotEmptyResult = IsNotEmpty(value);
    if (isNotEmptyResult.isValid == false) {
        if (required) {
            return isNotEmptyResult;
        } else {
            return new ValidationResult(true);
        }
    }
    const validResult = new ValidationResult(true);
    const invalidResult = new ValidationResult(false, 'message.must_be_empty_or_business_id');    
    if (!value || value === "") return validResult;
    if (value.match(/^[0-9]{6}-[0-9]{1}$/)) {
        value = '0' + value;
    }
    if (!value.match(/^[0-9]{7}-[0-9]{1}$/)) {
        return invalidResult;
    }
    const multipliers = [7, 9, 10, 5, 8, 4, 2];
    let sum = 0;
    for (let i = 0; i <= 6; i++) {
        sum = sum + parseInt(value.charAt(i)) * multipliers[i];
    }
    const remainder = sum % 11;
    if (remainder === 1) {
        return invalidResult;
    }
    const checksum = parseInt(value.charAt(8));
    if (remainder === 0 && checksum === 0) {
        return validResult;
    } else if (checksum === 11 - remainder) {
        return validResult;
    } else {
        return invalidResult;
    }
}

export const IsNotEmpty = function(value: string): ValidationResult {
    if (!value || value === '') return new ValidationResult(false, 'message.field_required');
    return new ValidationResult(true);
}

export const IsEmail = function(value: string, required: boolean = false): ValidationResult {
    const isNotEmptyResult = IsNotEmpty(value);
    if (isNotEmptyResult.isValid == false) {
        if (required) {
            return isNotEmptyResult;
        } else {
            return new ValidationResult(true);
        }
    }
    const re =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@(([^<>()[\]\\.,;:\s@"]+\.)+[^<>()[\]\\.,;:\s@"]{2,})$/i
    const result = re.test(value);
    if (!result) {
        return new ValidationResult(false, 'message.must_be_a_valid_email');
    }
    return new ValidationResult(true);
}

export const ValidateInputField = function(value: string, type: InputFieldType, required: boolean = false): ValidationResult {
    const isNotEmptyResult = IsNotEmpty(value);
    if (isNotEmptyResult.isValid == false) {
        if (required) {
            return isNotEmptyResult;
        } else {
            return new ValidationResult(true);
        }
    }
    let result: ValidationResult;
    switch (type) {
        case InputFieldType.Email: {
            result = IsEmail(value);
            break;
        }
        case InputFieldType.BusinessID: {
            result = IsBusinessId(value);
            break;
        }
        default: {
            result = new ValidationResult(true);
            break;
        }
    }
    return result;
}